const lightTheme = {
  colors: {
    primary: '#52311A',
    primaryTransparent: 'rgba(82, 49, 26, 0.2)',
    danger: '#DF3030',
    dangerTransparent: 'rgba(223, 48, 48, 0.1)',
    success: '#3CA422',
    successTransparent: 'rgba(60, 164, 34, 0.1)',
    warning: '#FFA800',
    warningTransparent: 'rgba(255, 168, 0, 0.1)',
    info: '#0075FF',
    infoTransparent: 'rgba(0, 117, 255, 0.1)',
    blackTransparent: 'rgba(0, 0, 0, 0.5)',

    white: '#ffffff',
    whiteDark: '#fafafa',
    whiteDarker: '#f1f1f1',

    grayE: '#eeeeee',
    grayD: '#dddddd',
    grayC: '#cccccc',
    gray9: '#999999',

    black2: '#222222',
    black3: '#333333',
    black5: '#555555',
    black7: '#777777',
  },
};

export default lightTheme;
